<template>
  <v-card
    elevation="3"
    class="auth-card pa-8"
  >
    <v-alert
      type="error"
      title="Authentication Error"
      class="mb-6"
      border="start"
      variant="tonal"
    >
      {{ error }}
    </v-alert>
    <v-btn
      color="primary"
      size="large"
      prepend-icon="mdi-home"
      @click="emit('return')"
    >
      Return to Home
    </v-btn>
  </v-card>
</template>

<script setup lang="ts">
interface Props {
  error: string
}

defineProps<Props>()
const emit = defineEmits<{
  return: []
}>()
</script>

<style scoped>
.auth-card {
  border-radius: 16px;
}

:deep(.v-alert) {
  border-radius: 8px;
}
</style> 